import { Box, Grid, Text } from "@chakra-ui/react";
import React from "react";
import { IWorkshopWithMentorModel, LocationEnum, Workshop } from "ui";

import { headerGradient } from "../../styles/customTheme";

interface IWorkshopGrid {
  workshops: IWorkshopWithMentorModel[];
}

export const WorkshopGrid: React.FC<IWorkshopGrid> = ({ workshops }) => {
  return (
    <>
      {workshops.length > 0 ? (
        <Grid templateColumns="repeat(auto-fit, minmax(300px, 1fr))" gap={5}>
          {workshops.map((workshop, index) => {
            return (
              <Workshop
                key={index}
                id={workshop.id}
                title={workshop.title}
                heroGradientStyles={headerGradient}
                mentor={workshop.mentor}
                online={LocationEnum.ONLINE in workshop.location.type}
                startDate={workshop?.dateTime?.startDate}
                endDate={workshop?.dateTime?.endDate}
                startTime={workshop?.dateTime?.startTime}
              />
            );
          })}
        </Grid>
      ) : (
        <Box display="flex" justifyContent="center" my={10}>
          <Text>
            Aktuell sind keine Workshops in dieser Kategorie verfügbar
          </Text>
        </Box>
      )}
    </>
  );
};
